/* eslint-disable @typescript-eslint/no-require-imports */
// CSS is injected synchronously into the DOM at bundle initialisation time.
// process.env.REACT_APP_CHANNEL_NAME is replaced by webpack's DefinePlugin with
// a literal string at build time. The dead branch is eliminated by Terser in
// production, so only the active channel's CSS ends up in the bundle.

import { getChannel } from 'utils';

// If the env var is not set (local dev), Layout.tsx handles dynamic loading.
if (getChannel().key === 'telus') {
  require('@unmind/design-system/dist/css/telus.components.css');
} else {
  require('@unmind/design-system/dist/css/unmind-light.components.css');
}
